module.exports = __webpack_public_path__ + "static/media/badge.e6f6d78a.svg";